module.exports = __webpack_public_path__ + "img/nologo.f1ed4050.svg";